import { SVGProps } from 'react';

export const TooltipTipBottom = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 9"
    fill="none"
    {...props}
  >
    <path
      d="M21.7433 0.5L20.2647 1.42383L13.3253 5.76172C12.5652 6.23678 11.6132 6.26636 10.8292 5.85059L10.6749 5.76172L3.73544 1.42383L2.25693 0.5H21.7433Z"
      fill="currentColor"
      stroke="#BFC0B9"
    />
    <path
      d="M3.00018 0H21.0002L20 0.999998H3.99999L3.00018 0Z"
      fill="currentColor"
    />
  </svg>
);
